import { useNavigate } from "react-router-dom";
import type { Project } from "@/mocks/projects";

interface ProjectHeroProps {
  project: Project;
}

export default function ProjectHero({ project }: ProjectHeroProps) {
  const navigate = useNavigate();

  return (
    <section className="relative h-[480px] md:h-[580px] w-full overflow-hidden">
      {/* Background Image */}
      <img
        src={project.image}
        alt={project.title}
        className="w-full h-full object-cover object-top"
      />
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0d1a2e]/85 via-[#0d1a2e]/40 to-[#0d1a2e]/20" />

      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-28 left-6 md:left-12 flex items-center gap-2 text-white/80 hover:text-white text-sm font-medium transition-colors duration-200 cursor-pointer group"
      >
        <div className="w-8 h-8 flex items-center justify-center rounded-full border border-white/30 group-hover:border-white/70 transition-colors duration-200">
          <i className="ri-arrow-left-line text-sm" />
        </div>
        Projelere Dön
      </button>

      {/* Content */}
      <div className="absolute bottom-0 left-0 right-0 px-6 md:px-12 pb-12">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-wrap items-center gap-3 mb-4">
            <span className="text-xs font-semibold text-[#4CAF50] uppercase tracking-widest bg-[#4CAF50]/15 px-3 py-1 rounded-full border border-[#4CAF50]/30">
              {project.category}
            </span>
          </div>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 leading-tight">
            {project.title}
          </h1>
          <div className="flex items-center gap-2 text-white/60 text-sm">
            <i className="ri-map-pin-2-line text-[#4CAF50]" />
            <span>{project.location}, Türkiye</span>
          </div>
        </div>
      </div>
    </section>
  );
}
